import { INFOR_CAR, INFOR_MAG4G, INFOR_MOTO } from 'src/app/constant/config';

export const MAX_LOG_LENGTH = 200;

export const PHONE_SEARCH_PAGE_SIZE = 10;

// Lịch sử tìm kiếm (localStorage): lưu tối đa / hiển thị tối đa trong dropdown
export const SEARCH_HISTORY_KEY = 'customer_care_lookup_search_history';
export const SEARCH_HISTORY_MAX = 20;
export const SEARCH_HISTORY_SHOW = 8;

// SĐT VN (có thể nhập một phần): bắt đầu bằng 0 / 84 / +84, chỉ gồm chữ số
export const PHONE_QUERY_REGEX = /^(\+?84|0)\d{3,10}$/;

export const MQTT_TYPE_COLOR = {
  PERIODIC: '#1976d2',
  EVENT: '#f0ad4e',
  FEEDBACK: '#28a745',
  DEBUG: '#8a8a8a',
  CONTROL: '#6f42c1',
  ACTIVATE: '#6f42c1'
};

export const VEHICLE_STATUS_LABEL = {
  moving: 'Đang di chuyển',
  stopped: 'Dừng đỗ',
  over_speed: 'Quá tốc độ',
  lost_gps: 'Mất tín hiệu GPS',
  lost_gsm: 'Mất tín hiệu 4G'
};

export const VEHICLE_STATUS_COLOR = {
  moving: '#28a745',
  stopped: '#8a8a8a',
  over_speed: '#d9042f',
  lost_gps: '#f0ad4e',
  lost_gsm: '#f0ad4e'
};

export const INFO_BOX_MAP = {
  VGPS_MOTO4G: INFOR_MOTO,
  VGPS_MAG4G: INFOR_MAG4G,
  VGPS_CAR4G: INFOR_CAR,
  VGPS_2CAM: INFOR_CAR,
  VGPS_4CAM: INFOR_CAR
};
